import React from 'react';
import ReactDOM from 'react-dom';
import Index from './index.jsx';

ReactDOM.render(
  <Index />,
  document.getElementById('root')
);